import { schema } from 'normalizr';
import { fileSchema } from './fileSchema';

export const referralFormSchema = new schema.Entity('referralForm', {
  headerPhotoFileId: fileSchema,
});
